import { Colors } from 'constants/colors'
import React from 'react'
import { BounceLoader } from 'react-spinners'

export default function Spinner(): JSX.Element {
  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <BounceLoader
        color={Colors.maastrichtBlue}
        size={50}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  )
}
